import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { LayoutDashboard, FileText, Menu, X } from 'lucide-react';

const Layout = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleNavClick = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header with Dropdown */}
      <div className="bg-white border-b border-slate-200 px-6 py-4 sticky top-0 z-50">
        <div className="max-w-3xl mx-auto flex justify-between items-center">
          <h1 className="text-2xl font-bold text-slate-900 tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Daily Groceries
          </h1>
          
          {/* Desktop Navigation */}
          <div className="hidden sm:flex gap-2">
            <NavLink
              to="/dashboard"
              className={({ isActive }) =>
                `flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all ${
                  isActive
                    ? 'bg-blue-600 text-white'
                    : 'text-slate-600 hover:bg-slate-100'
                }`
              }
              style={{ fontFamily: 'Manrope, sans-serif' }}
              data-testid="nav-dashboard-link"
            >
              <LayoutDashboard className="h-4 w-4" />
              Dashboard
            </NavLink>

            <NavLink
              to="/reports"
              className={({ isActive }) =>
                `flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all ${
                  isActive
                    ? 'bg-blue-600 text-white'
                    : 'text-slate-600 hover:bg-slate-100'
                }`
              }
              style={{ fontFamily: 'Manrope, sans-serif' }}
              data-testid="nav-reports-link"
            >
              <FileText className="h-4 w-4" />
              Reports
            </NavLink>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="sm:hidden p-2 text-slate-600 hover:bg-slate-100 rounded-lg transition-colors"
            data-testid="mobile-menu-button"
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Dropdown Menu */}
        {isMenuOpen && (
          <div className="sm:hidden mt-4 pb-2">
            <div className="flex flex-col gap-2">
              <button
                onClick={() => handleNavClick('/dashboard')}
                className="flex items-center gap-3 px-4 py-3 text-slate-700 hover:bg-slate-100 rounded-lg transition-colors text-left"
                style={{ fontFamily: 'Manrope, sans-serif' }}
                data-testid="mobile-nav-dashboard"
              >
                <LayoutDashboard className="h-5 w-5" />
                <span className="font-medium">Dashboard</span>
              </button>

              <button
                onClick={() => handleNavClick('/reports')}
                className="flex items-center gap-3 px-4 py-3 text-slate-700 hover:bg-slate-100 rounded-lg transition-colors text-left"
                style={{ fontFamily: 'Manrope, sans-serif' }}
                data-testid="mobile-nav-reports"
              >
                <FileText className="h-5 w-5" />
                <span className="font-medium">Reports</span>
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Main Content */}
      <Outlet />
    </div>
  );
};

export default Layout;